import * as yup from "yup";
import { nameof } from "ts-simple-nameof";
import { VehicleBaseParamsValidationRuleObject } from "../baseParams";
import type { BaseParamsVehicleDto } from "../../dtos";

export const BaseParamsValidationSchema = yup.object().shape({
    ...VehicleBaseParamsValidationRuleObject,
    [nameof<BaseParamsVehicleDto>(x => x.pov)]: yup.array().optional(),
    [nameof<BaseParamsVehicleDto>(x => x.insurers)]: yup.array().optional(),
    [nameof<BaseParamsVehicleDto>(x => x.addonInsurers)]: yup.array().nullable().min(1, "Vyberte pojišťovnu")
}) as any